export class AssetComponentTransferAdd {
    assetComponentOldIds: number[];
    assetComponentNewIds: number[];
    employeeId: number;
    invStateId: number;
}
